<template>
  <section id="dashboard">
    <b-row class="match-height">
      <b-col
          xl="12"
          md="12"
      >
        <users-statistics :data="data" />
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col lg="6">
        <objectif-section />
      </b-col>
      <b-col lg="6">
        <evaluation-section  />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {BRow, BCol} from 'bootstrap-vue'
import UsersStatistics from "@/views/dashboard/UsersStatistics.vue";
import ObjectifSection from "@/views/dashboard/ObjectifSection.vue";
import EvaluationSection from "@/views/dashboard/EvaluationSection.vue";
import {getCountUsers} from "@/services/UserService";


export default {
  components: {
    BRow,
    BCol,
    UsersStatistics,
    ObjectifSection,
      EvaluationSection,
  },
  data() {
    return {
      data: {
        countUser:0,
        countByDisabledFalse:0,
        countByDisabledTrue:0,
      },
    }
  },
  methods:{
    async getCountUsers(){
      this.data = await getCountUsers();
    }

  },
  mounted(){
    this.getCountUsers();

  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>